module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAE1JREFUeNpi+P//PwMWnADE77FJKPyHgPkwDrLkfiA+D2IzQFWBBAyQdDnAJB2gKt9DFd2HmYJs3HmorgSYGBMDAmwE4g9AvAEmABBgALkMjahVZFUMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/haken_weiss.png
// module id = 170
// module chunks = 51